import * as Q from 'q';
import { Observable } from 'rxjs/Observable';
import { VasAppFacade } from '../../vas/services/vas-app-facade.service';
import { IStatusResponse, VASRestService } from '../services/api/vas-rest';
import { ISchedulable } from '../services/scheduler/schedulable.interface';
import { ChangeQItem } from '../services/sync-up/item';
import { SyncUpService } from '../services/sync-up/sync-up.service';
import { SyncUpEndEvent, SyncUpStartEvent } from '../system/system.actions';
import { Facade } from './facade';

export class SyncUpFacade extends Facade implements ISchedulable {

    protected service: SyncUpService;

    constructor(
        protected appFacade: VasAppFacade,
        protected api: VASRestService
    ) {
        super(appFacade);

        this.service = new SyncUpService(appFacade, api);

        this.appFacade.changeLog.getChangesWaiting()
            .throttleTime(1000)
            .subscribe(
                count => {
                    if (count > 0) {
                        this.service.syncRequest();
                    }
                },
                error => console.error(error)
            );

        this.service.active$.subscribe(value => {
            if (value === true) {
                this.appFacade.triggerSystemEvent(new SyncUpStartEvent());
            } else {
                this.appFacade.triggerSystemEvent(new SyncUpEndEvent());
            }
        });

        // this.service.active$.subscribe(active => {
        //     if (active) {
        //         this.appFacade.loading.showLoading();
        //     } else {
        //         this.appFacade.loading.hideLoading();
        //     }
        // });

        this.service.error$.subscribe(error => {
            this.appFacade.toast.toastDanger(error);
        });
    }

    async sync(force: boolean = false): Promise<any> {

        const status: IStatusResponse = await this.appFacade.network.refreshStatusP();

        if (!status.ip) {
            return;
        }

        return this.service.sync(force);
    }

    forceSyncUp(): Promise<any> {
        return [
            () => this.appFacade.network.refreshStatusP(),
            () => this.service.sync(true)
        ].reduce<any>(Q.when, Q());
    }

    syncUpItem(item: ChangeQItem): Promise<any> {
        return this.service.syncUpItem(item);
    }

    syncRequest(): void {
        this.service.syncRequest();
    }

    getSchedulerId(): string {
        return SyncUpService.CLASS;
    }

    isBusy(): boolean {
        return this.service.isBusy();
    }

    get busy$(): Observable<boolean> {
        return this.service.active$;
    }

    run(): Promise<any> {
        return this.service.sync();
    }

    stop(): void {
        return this.service.stop();
    }
}



// WEBPACK FOOTER //
// ./src/core/facades/sync-up-facade.ts